import React from "react";
import { motion } from "framer-motion";
import axios from "axios";
import { useQuery } from "@tanstack/react-query";
import { FaMapMarkerAlt } from "react-icons/fa";
import {
  currencyDisplay,
  getCardIcon,
  getGrowthIconClass,
} from "../helpers/commonHelper";

const Location = ({ onBack, reportType, subReport, clientData }) => {
  const clientid = sessionStorage.getItem("clientId");
  const token = sessionStorage.getItem("token");
  const locationID = JSON.parse(sessionStorage.getItem("selectedLocation"));
  const adminInfo = JSON.parse(sessionStorage.getItem("adminInfo") || "null");

  const fetchSubReport = async (reportType) => {
    if (!clientid || !token || reportType === null) return null;

    const baseRequest = {
      clientid: clientid,
    };

    if (reportType === 1 || reportType === 2) {
      return (
        await axios.post(
          `${process.env.REACT_APP_BACKEND_API_URL}/clients/summarydetails`,
          {
            ...baseRequest,
            type: "get",
            dataurl: "/api/DashBoardSubReport",
            subdata: { ReportType: reportType },
          },
          {
            headers: {
              Authorization: `Bearer ${token}`,
              "Content-Type": "application/json",
            },
          },
        )
      ).data.result;
    }

    if (reportType === 1001 || reportType === 1002) {
      const locations = JSON.parse(sessionStorage.getItem("locations") || "[]");

      return (
        await axios.post(
          `${process.env.REACT_APP_BACKEND_API_URL}/clients/summarydetails`,
          {
            ...baseRequest,
            dataurl: "/api/DashBoardSubReport/AccountSubReport",
            subdata: {
              ReportType: reportType,
              loations: locations,
            },
          },
          {
            headers: {
              Authorization: `Bearer ${token}`,
              "Content-Type": "application/json",
            },
          },
        )
      ).data.result;
    }

    return null;
  };

  const { data: reportData, isLoading: reportLoading } = useQuery({
    queryKey: ["subReport", reportType],
    queryFn: () => fetchSubReport(reportType),
    enabled:
      !!clientid &&
      !!token &&
      adminInfo?.multiple_location?.length === 0 &&
      reportType !== null &&
      (reportType === 1 ||
        reportType === 2 ||
        reportType === 1001 ||
        reportType === 1002),
    staleTime: 1000 * 60 * 5,
  });

  const MutipleLocationFetchSubReport = async (reportType) => {
    if (!locationID || !token || reportType === null) return null;

    const baseRequest = {
      id: locationID,
    };

    if (reportType === 1 || reportType === 2) {
      return (
        await axios.post(
          `${process.env.REACT_APP_BACKEND_API_URL}/clients/multipleLocations-summarydetails`,
          {
            ...baseRequest,
            type: "get",
            dataurl: "/api/DashBoardSubReport",
            subdata: { ReportType: reportType },
          },
          {
            headers: {
              Authorization: `Bearer ${token}`,
              "Content-Type": "application/json",
            },
          },
        )
      ).data.result;
    }

    if (reportType === 1001 || reportType === 1002) {
      const locations = JSON.parse(sessionStorage.getItem("locations") || "[]");

      return (
        await axios.post(
          `${process.env.REACT_APP_BACKEND_API_URL}/clients/multipleLocations-summarydetails`,
          {
            ...baseRequest,
            dataurl: "/api/DashBoardSubReport/AccountSubReport",
            subdata: {
              ReportType: reportType,
              loations: locations,
            },
          },
          {
            headers: {
              Authorization: `Bearer ${token}`,
              "Content-Type": "application/json",
            },
          },
        )
      ).data.result;
    }

    return null;
  };

  const { data: reportDatas, isLoading: reportLoadings } = useQuery({
    queryKey: ["subReports", reportType],
    queryFn: () => MutipleLocationFetchSubReport(reportType),
    enabled:
      !!token &&
      adminInfo?.multiple_location.length >= 1 &&
      reportType !== null &&
      (reportType === 1 ||
        reportType === 2 ||
        reportType === 1001 ||
        reportType === 1002),
    staleTime: 1000 * 60 * 5,
  });

  const data = reportDatas ? reportDatas : reportData;

  return (
    <div className="w-full">
      {reportType === 1 ||
      reportType === 2 ||
      reportType === 1001 ||
      reportType === 1002 ? (
        reportLoading || reportLoadings || !data ? (
          <div className="flex justify-center items-center py-6">
            <div className="w-6 h-6 border-4 border-indigo-500 border-t-transparent rounded-full animate-spin"></div>
          </div>
        ) : (
          <>
            <div className="sticky top-0 z-20 bg-white pb-2 px-4 pt-6">
              <span className="inline-block mb-2" onClick={onBack}>
                <i className="ri-arrow-go-back-fill text-[20px] text-gray-500 cursor-pointer"></i>
              </span>
              <h1 className="font-QBold my-2">{data?.reportName} Summary</h1>
              <div className="flex justify-between mb-2 text-sm font-QBold border-b border-gray-100 pb-2">
                <h1>Name</h1>
                <h1>Balance ({clientData?.mainCurrencyName})</h1>
              </div>
            </div>

            <div className="pt-2 px-4">
              {data?.summary?.map((item, idx) => (
                <motion.div
                  key={idx}
                  initial={{ opacity: 0, y: 50 }}
                  animate={{ opacity: 1, y: 0 }}
                  transition={{
                    type: "spring",
                    stiffness: 80,
                    damping: 15,
                    duration: 0.2,
                    ease: "easeOut",
                  }}
                  className="flex justify-between items-center bg-white rounded-xl px-4 py-6 mb-3 shadow-md"
                >
                  <div className="text-xs text-gray-500 font-QSemiBold mt-0.5">
                    {item.name}
                  </div>
                  <div className="text-indigo-700 w-[45%] font-QSemiBold text-right text-xs">
                    {clientData?.mainCurrencyName}{" "}
                    {currencyDisplay(item.balance)}
                  </div>
                </motion.div>
              ))}
            </div>
            <div className="h-44"></div>
          </>
        )
      ) : (
        <>
          <div className="sticky top-0 z-20 bg-white pb-2 px-4 pt-6">
            <span className="inline-block mb-2" onClick={onBack}>
              <i className="ri-arrow-go-back-fill text-[20px] text-gray-500 cursor-pointer"></i>
            </span>
            <h1 className="font-QBold my-2">
              {subReport.length > 0 && subReport[0].type} Summary
            </h1>
          </div>

          <div className="grid grid-cols-1 sm:grid-cols-2 gap-4 pt-2 px-4 mb-8">
            {subReport.map((item, index) => (
              <motion.div
                key={index}
                initial={{ opacity: 0, y: 50 }}
                animate={{ opacity: 1, y: 0 }}
                transition={{
                  type: "spring",
                  stiffness: 80,
                  damping: 15,
                  duration: 0.3,
                  delay: index * 0.2,
                  ease: "easeOut",
                }}
                whileHover={{
                  scale: 1.05,
                  transition: { duration: 0.1, ease: "easeInOut" },
                }}
                className="w-full relative"
              >
                {/* Location Name - top-left */}
                <div className="absolute flex top-[-6px] left-[-9px] text-xs font-QSemiBold text-white bg-indigo-500 px-2 py-[5px] items-center rounded-md shadow-md">
                  <FaMapMarkerAlt className="text-white text-sm mr-2" />
                  <span>{item.locationName}</span>
                </div>

                {/* Growth% - top-right */}
                <div className="absolute flex items-center top-7 right-4 text-xs font-QSemiBold text-green-600 bg-green-100 px-2 py-0.5 rounded-md">
                  <i
                    className={`${getGrowthIconClass(
                      item.subAmountCaptionIcon,
                    )} text-sm mr-1`}
                  ></i>
                  <span>
                    {item.subAmount} {item.subAmountCaption}
                  </span>
                </div>

                <Card
                  icon={getCardIcon(item.type)}
                  value={currencyDisplay(item.amount)}
                  currency={clientData?.mainCurrencyName}
                  clientData={clientData}
                  label={item.type}
                  accentColor="bg-gradient-to-r from-indigo-100 to-indigo-200"
                />
              </motion.div>
            ))}
          </div>
          <div className="h-40"></div>
        </>
      )}
    </div>
  );
};

const Card = ({
  icon,
  value,
  label,
  accentColor,
  highlight,
  clientData = false,
}) => (
  <div
    className={`${accentColor} p-4 cursor-pointer rounded-2xl flex flex-col items-center ${
      highlight ? "shadow-md" : "border border-gray-200"
    }`}
  >
    <div className="relative mb-1 bg-white/45 p-3 rounded-full border w-16 h-16 border-gray-100 flex items-center justify-center">
      {icon}
    </div>
    <h3 className="text-lg font-QSemiBold text-gray-800">
      {clientData?.mainCurrencyName} {value}
    </h3>
    <p
      className={`text-sm font-QSemiBold ${
        highlight ? "text-gray-800" : "text-gray-500"
      }`}
    >
      {label}
    </p>
  </div>
);

export default Location;
